"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

exports.__esModule = true;

var prop_types_1 = __importDefault(require("prop-types"));

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var styles_1 = require("../../common/styles");

var GenericWidget_1 = __importDefault(require("./GenericWidget"));

var _utilities_1 = require("../../utilities");

var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), styles_1.general);

var Widgets =
/** @class */
function (_super) {
  __extends(Widgets, _super);

  function Widgets(props) {
    var _this = _super.call(this, props) || this;

    _this.renderWidgets = _this.renderWidgets.bind(_this);
    return _this;
  }

  Widgets.prototype.componentDidCatch = function (e) {
    console.error('Uncaught error in csm-widgets!', e);
  };

  Widgets.prototype.renderWidgets = function (items) {
    var _a = this.props,
        override = _a.override,
        renderEmpty = _a.renderEmpty,
        renderLink = _a.renderLink;
    return _utilities_1.transformDeprecatedContent(items).map(function (widget, idx) {
      var key = "widget_" + widget.type + "_" + idx;

      if (widget.type in override) {
        return react_1["default"].createElement(react_1["default"].Fragment, {
          key: key
        }, override[widget.type](widget));
      }

      return react_1["default"].createElement(GenericWidget_1["default"], {
        key: key,
        widget: widget,
        renderLink: renderLink,
        renderEmpty: renderEmpty
      });
    });
  };

  Widgets.prototype.render = function () {
    var items = this.props.items;
    return react_1["default"].createElement(Wrapper, null, this.renderWidgets(items));
  };

  return Widgets;
}(react_1.PureComponent);

Widgets.propTypes = {
  override: prop_types_1["default"].objectOf(prop_types_1["default"].func),
  items: prop_types_1["default"].arrayOf(prop_types_1["default"].shape({
    type: prop_types_1["default"].string.isRequired
  })),
  renderLink: prop_types_1["default"].func,
  renderEmpty: prop_types_1["default"].func
};
Widgets.defaultProps = {
  items: [],
  override: {},
  renderLink: undefined,
  renderEmpty: undefined
};
exports["default"] = Widgets;
var templateObject_1;